/*
  Юридический список 23.09 (EU), правки 28.09.2026.

  1) Строка Omnibus (ст. 6a директивы 98/6/ЕС в редакции 2019/2161): рядом с каждой объявленной скидкой —
     самая низкая цена за 30 дней до снижения. На витрине это та же зачёркнутая цена, от которой считается
     «−N %», поэтому строка берёт её прямо с экрана: разойтись с бейджем, сменой варианта или акцией она не может.
     Статичные места (карточки каталога, корзина, допы в корзине, слайдер, блог) рисуются в Liquid —
     snippets/evamats-omnibus-line.liquid. Здесь — только то, что пересчитывает JS: итог у кнопки и нижняя
     панель конфигуратора (скидка по акции — evamats-promo-display.js, уценка — product-config.js/product.js),
     допы в конфигураторе, цены велюра и пояснение под сеткой наборов, где зачёркнутых цен несколько.
  2) Кнопка «Настройки cookies» в подвале открывает окно настроек баннера Shopify.
*/
(function () {
  'use strict';

  var I18N = window.EVAMATS_I18N || {};
  var LINE = I18N.omnibusLine || '';
  var SHORT = I18N.omnibusShort || LINE;
  var NOTE = I18N.omnibusNote || '';

  function hiddenSelf(el) {
    if (!el) return true;
    if (el.hidden || el.classList.contains('hidden')) return true;
    var s = window.getComputedStyle(el);
    return s.display === 'none' || s.visibility === 'hidden';
  }

  /* текст цены без скрытых подписей («Обычная цена» для читалок) */
  function priceText(el) {
    if (!el || hiddenSelf(el)) return '';
    var c = el.cloneNode(true);
    c.querySelectorAll('.visually-hidden, [aria-hidden="true"]').forEach(function (x) {
      x.remove();
    });
    var t = (c.textContent || '').replace(/\s+/g, ' ').trim();
    return /\d/.test(t) ? t : '';
  }

  /* цена «до снижения» в строке итога: при акции зачёркнута обычная цена, при уценке — compare_at */
  function priorInTotal(row) {
    if (row.classList.contains('eva-promo-on')) return row.querySelector('.sticky_config_price_price');
    return row.querySelector('.evamats-config-checkout__price-old, .sticky_config_price_compare');
  }

  var UNITS = [
    { row: '.evamats-config-checkout__total-row', prior: priorInTotal, where: 'after', text: function () { return LINE; } },
    { row: '.evamats-config-step-bar__price-row', prior: priorInTotal, where: 'inside', text: function () { return SHORT; } },
    /* та же строка для телефона — в левой колонке панели (CSS показывает одну из двух по ширине экрана) */
    { row: '.evamats-config-step-bar__price-row', prior: priorInTotal, where: 'info', text: function () { return SHORT; } },
    { row: '.product__upsell_price-row', prior: function (r) { return r.querySelector('.product__upsell_price_compare'); }, where: 'after', text: function () { return LINE; } },
    /* велюр: строка после блока цены — отдельной строкой карточки, а не в колонке цены (см. evamats-legal.css) */
    { row: '.ecm-price-stack', prior: function (r) { return r.querySelector('[data-ecm-compare-price]'); }, where: 'after', text: function () { return LINE; } },
    { row: '.ecm-step-head', prior: function (r) { return r.querySelector('.ecm-pill-compare'); }, where: 'inside', text: function () { return LINE; } },
    { row: '.cart-upsell-strip__priceline', prior: function (r) { return r.querySelector('.cart-upsell-strip__old-value'); }, where: 'after', text: function () { return LINE; } }
  ];

  function barInfo(row) {
    var bar = row.closest('.evamats-config-step-bar');
    return bar && bar.querySelector('.evamats-config-step-bar__info');
  }

  function lineFor(row, unit) {
    if (unit.where === 'info') {
      var info = barInfo(row);
      return info ? info.querySelector(':scope > .evamats-omnibus') : null;
    }
    if (unit.where === 'inside') {
      var own = row.querySelector(':scope > .evamats-omnibus');
      if (own) return own;
    } else {
      var next = row.nextElementSibling;
      if (next && next.classList.contains('evamats-omnibus')) return next;
    }
    return null;
  }

  function makeLine(row, unit) {
    var el = document.createElement('small');
    el.className = 'evamats-omnibus';
    el.setAttribute('data-evamats-omnibus', 'js');
    el.hidden = true;
    if (unit.where === 'info') {
      var info = barInfo(row);
      if (!info) return null;
      info.appendChild(el);
    } else if (unit.where === 'inside') row.appendChild(el);
    else row.insertAdjacentElement('afterend', el);
    return el;
  }

  function setLine(el, text) {
    if (!el) return;
    if (!text) {
      if (!el.hidden) el.hidden = true;
      return;
    }
    if (el.textContent !== text) el.textContent = text;
    if (el.hidden) el.hidden = false;
  }

  /* сетка наборов конфигуратора: у каждого набора своя зачёркнутая цена — одно пояснение под сеткой */
  function syncGroupNotes() {
    if (!NOTE) return;
    document.querySelectorAll('.evamats-config fieldset[data-name="mats_set"]').forEach(function (field) {
      var struck = [].some.call(field.querySelectorAll('label'), function (label) {
        if (label.classList.contains('eva-promo-on') && priceText(label.querySelector('.label__tooltip'))) return true;
        return !!priceText(label.querySelector('.option__price_compare'));
      });
      /* 30.09.2026, владелец: пояснение не под сеткой наборов, а над ней и мелким шрифтом — «для галочки» */
      var note = field.previousElementSibling;
      if (!note || !note.classList.contains('evamats-omnibus--note')) {
        if (!struck) return;
        note = document.createElement('p');
        note.className = 'evamats-omnibus evamats-omnibus--note';
        note.setAttribute('data-evamats-omnibus', 'note');
        field.insertAdjacentElement('beforebegin', note);
      }
      setLine(note, struck ? NOTE : '');
    });
  }

  var observer = null;
  function sync() {
    if (!LINE) return;
    try {
      UNITS.forEach(function (unit) {
        document.querySelectorAll(unit.row).forEach(function (row) {
          var price = priceText(unit.prior(row));
          var el = lineFor(row, unit);
          if (!price) {
            setLine(el, '');
            return;
          }
          if (!el) el = makeLine(row, unit);
          setLine(el, unit.text().replace('__P__', price));
        });
      });
      syncGroupNotes();
    } finally {
      /* sync синхронный — пока он шёл, чужие скрипты ничего не меняли; в очереди только наши записи */
      if (observer) observer.takeRecords();
    }
  }

  var pending = 0;
  function schedule() {
    if (pending) return;
    pending = window.requestAnimationFrame(function () {
      pending = 0;
      sync();
    });
  }

  /* кнопка «Настройки cookies»: пункт скрыт, пока нет API баннера Shopify (регион без баннера, блокировщик) */
  function cookieApi() {
    return window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function';
  }
  function revealCookieItems() {
    if (!cookieApi()) return false;
    document.querySelectorAll('[data-cookie-settings-item][hidden]').forEach(function (li) {
      li.hidden = false;
    });
    return true;
  }
  var cookieTries = 0;
  (function waitCookieApi() {
    if (revealCookieItems() || ++cookieTries > 40) return;
    setTimeout(waitCookieApi, 500);
  })();

  document.addEventListener('click', function (event) {
    var btn = event.target && event.target.closest && event.target.closest('[data-cookie-settings]');
    if (!btn) return;
    event.preventDefault();
    if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
      window.privacyBanner.showPreferences();
    }
  });

  function boot() {
    sync();
    if (window.MutationObserver) {
      observer = new MutationObserver(function (records) {
        for (var i = 0; i < records.length; i++) {
          var t = records[i].target;
          var el = t.nodeType === 1 ? t : t.parentElement;
          /* наши же строки не будят наблюдателя */
          if (el && el.closest && el.closest('[data-evamats-omnibus]')) continue;
          schedule();
          return;
        }
      });
      observer.observe(document.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class', 'hidden'] });
    }
    setTimeout(sync, 800);
    setTimeout(sync, 2000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
